import { useTranslation } from 'react-i18next';
import { legalConfig } from '../config/legal';

export type PrivacyNoticeVariant =
  | 'default'
  | 'uploadIdentity'
  | 'uploadMedical'
  | 'uploadOther'
  | 'booking'
  | 'dataExport';

type Props = {
  variant?: PrivacyNoticeVariant;
  className?: string;
};

export function PrivacyNotice({ variant = 'default', className = '' }: Props) {
  const { t } = useTranslation();
  const email = legalConfig.privacyContactEmail;

  return (
    <div className={`rounded-lg border border-primary-200 bg-primary-50 px-4 py-3 text-sm text-textSecondary ${className}`}>
      <p>{t(`legal.notice.${variant}`)}</p>
      <p className="mt-2">
        <a
          href={legalConfig.privacyPolicyUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="fo-link"
        >
          {t('legal.privacyPolicyLink')}
        </a>
        {' · '}
        <a href={`mailto:${email}`} className="fo-link">
          {email}
        </a>
      </p>
    </div>
  );
}
